<template>
  <div class="table_card">
    <div class="table_card__head">
      <v-layout row wrap>
        <v-flex lg12>
          <p class="table_card__head--title">
            Importador de características de usuario
          </p>
          <v-breadcrumbs class="breadcums">
            <v-icon slot="divider">chevron_right</v-icon>
            <v-breadcrumbs-item
              @click="$router.push({name: 'segments'})"
              class="breadcums__option"
            >
              Características de usuario
            </v-breadcrumbs-item>
            <v-breadcrumbs-item
              disabled
              class="breadcums__disable"
            >
              Importar características de usuario
            </v-breadcrumbs-item>
          </v-breadcrumbs>
        </v-flex>
      </v-layout>
    </div>
    <div class="table_card__body">
      <v-layout row wrap>
        <v-flex xs8>
          <div :style="excelTitle.length<=0?'margin-left:5%; margin-top:33px':''">
            <!-- Fotos de la oferta -->
            <span class="table_card__info--label">Adjuntar información (Formato Excel)</span>
            <div class="trainers__form--photo_container" style="width:max-content">
              <label
                for="excel_input"
                class="faccess_button buttom_shadow px-5">Examinar</label>
              <input
                id="excel_input"
                type="file"
                @change="excelUpload()"
                name="logo"
                multiple>
                <p class="accessIndex__text--small" style="margin-left:10%" v-if="excelTitle.length<=0" >Debe adjuntar un archivo con formato Excel</p>
            </div>
            </div>
          <v-flex>
              <div v-if="excelTitle.length!=0">
                <p class="data_card__info--label">Nombre del archivo </p>
                <p style="font-size: 10px;" ><img style="width:26px" src="https://karrottsportlife.s3-us-west-2.amazonaws.com/excel.png"/>{{excelTitle}}</p>
              </div>
          </v-flex>
          <v-flex xs12 style="margin-top:50px">
            <p class="accessIndex__text--small_bold"  v-if="segments.length>0" style="text-decoration: underline; margin-bottom: 25px;"> NUEVAS CARACTERÍSTICAS</p>
            <div v-for="(segment,index) in segments" :key= index :id="('bar'+segment[0]).toLowerCase().replace(/ /g,'')">
              <div class="accessIndex__locations--segment_item">
                <div class="accessIndex__locations--item_segment" >
                  <p class="accessIndex__text--small_bold">{{segments[index][0].charAt(0).toUpperCase() + segments[index][0].slice(1)}} </p>
                  <div  v-for="(value,position) in segment[1]" :key= position>
                    <v-flex style="display:list-item; margin-left:20px;list-style-type: circle;" v-if="segment[1][position][1]==''&&renderComponents">
                      <p class="accessIndex__text--small" style="margin-top:0px;width:100%;padding:12px;padding-left:5px ;height:fit-content" >
                        {{value[0].charAt(0).toUpperCase() + value[0].slice(1)}}
                      </p>
                    </v-flex>
                    <v-flex style="display:flex" v-if="segment[1][position][1]!=''&&renderComponents">
                      <input class="accessIndex__text--small" style="margin-top:16px;width:20%;padding:12px;padding-left:5px ;height:fit-content" :placeholder="value[0]" @change="value[0]= $event.target.value" @focus="$event.target.select()" :value="value[0]" >
                      <v-card-text  style="margin-top:-18px;">
                        <v-layout >
                          <v-flex class="px-4">

                            <v-range-slider
                              v-model="value[1]"
                              :max="maxRange(segment[0].toLowerCase())"
                              :smin="0"
                              :step="sliderStep(maxRange(segment[0].toLowerCase()))"
                              hide-details
                              class="align-center"
                              thumb-label
                              ticks
                              type="decimal"
                              v-if="renderComponents"
                              @change="moveSlider(value,position,segment[1],maxRange(segment[0].toLowerCase()))"
                            >
                              <template v-slot:prepend>
                                <v-text-field
                                  v-model="value[1][0]"
                                  class="mt-0 pt-0"
                                  hide-details
                                  disabled
                                  single-line
                                  type="float"
                                  style="width: 60px"
                                ></v-text-field>
                              </template>
                              <template v-slot:append>
                                <v-text-field
                                  v-model="value[1][1]"
                                  disabled
                                  class="mt-0 pt-0"
                                  hide-details
                                  single-line
                                  type="float"
                                  style="width: 60px"
                                ></v-text-field>
                              </template>
                            </v-range-slider>
                          </v-flex>
                          <div v-if="segment[1].length>1" @click="deleteValue(segment,position)"
                            class="data_card__buttons--delete">
                            <v-icon dark left>remove_circle</v-icon>
                          </div>
                        </v-layout>
                      </v-card-text>
                    </v-flex>
                  </div>
                  <div class="data_card__buttons" v-if="segment[1].length>0 && segment[1][0][1]!=''" >
                    <v-flex style="display:flex; width: fit-content;"
                        @click="addSegmentValue(segment[1]);">
                      <div
                        class="data_card__buttons--edit">
                        <v-icon>add</v-icon>
                      </div>
                      <p class="accessIndex__text--small" style="margin-top:12px;margin-left:10px">Añadir nueva categoría</p>
                    </v-flex>
                  </div>
                </div>
              </div>
            </div>
            <!-- EDICIÓN DE SEGMENTOS -->
            <p class="accessIndex__text--small_bold"  v-if="editSegments.length>0" style="text-decoration: underline; margin-bottom: 25px;">EDITAR CARACTERÍSTICAS</p>
            <div v-for="(segment,indexe) in editSegments" :key= indexe :id="('bare'+segment[0]).toLowerCase().replace(/ /g,'')">
              <div class="accessIndex__locations--segment_item">
                <div class="accessIndex__locations--item_segment" >
                  <p class="accessIndex__text--small_bold">{{editSegments[indexe][0].charAt(0).toUpperCase() + editSegments[indexe][0].slice(1)}} </p>
                  <div  v-for="(value,position) in segment[1]" :key= position>
                    <v-flex style="display:list-item; margin-left:20px;list-style-type: circle;" v-if="(!segment[1][position][1] ||segment[1][position][1]==''|| segment[1][position][1].length==0 )&&renderComponents">
                      <p class="accessIndex__text--small" style="margin-top:0px;width:100%;padding:12px;padding-left:5px ;height:fit-content" >
                        {{value[0].charAt(0).toUpperCase() + value[0].slice(1)}}
                      </p>
                    </v-flex>
                    <v-flex style="display:flex" v-if="segment[1][position][1]&&(segment[1][position][1]!=''|| segment[1][position][1].length>0 )&&renderComponents">
                      <input class="accessIndex__text--small" style="margin-top:16px;width:20%;padding:12px;padding-left:5px ;height:fit-content" :placeholder="value[0]" @change="value[0]= $event.target.value" @focus="$event.target.select()" :value="value[0]" >
                      <v-card-text  style="margin-top:-18px;">
                        <v-layout >
                          <v-flex class="px-4">
                            <v-range-slider
                              v-model="value[1]"
                              :max="maxRange(segment[0].toLowerCase())"
                              :smin="0"
                              :step="sliderStep(maxRange(segment[0].toLowerCase()))"
                              hide-details
                              class="align-center"
                              thumb-label
                              ticks
                              type="decimal"
                              v-if="renderComponents"
                              @change="moveSlider(value,position,segment[1],maxRange(segment[0].toLowerCase()))"
                            >
                              <template v-slot:prepend>
                                <v-text-field
                                  v-model="value[1][0]"
                                  class="mt-0 pt-0"
                                  hide-details
                                  single-line
                                  type="float"
                                  style="width: 60px"
                                  disabled
                                ></v-text-field>
                              </template>
                              <template v-slot:append>
                                <v-text-field
                                  v-model="value[1][1]"

                                  class="mt-0 pt-0"
                                  hide-details
                                  single-line
                                  type="float"
                                  style="width: 60px"
                                  disabled
                                ></v-text-field>
                              </template>
                            </v-range-slider>
                          </v-flex>
                          <div v-if="segment[1].length>1" @click="deleteValue(segment,position)"
                            class="data_card__buttons--delete">
                            <v-icon dark left>remove_circle</v-icon>
                          </div>
                        </v-layout>
                      </v-card-text>
                    </v-flex>
                  </div>
                  <div class="data_card__buttons" v-if="segment[1].length>0 && segment[1][0][1]!=''" >
                    <v-flex style="display:flex; width: fit-content;"
                        @click="addSegmentValue(segment[1]);">
                      <div
                        class="data_card__buttons--edit">
                        <v-icon>add</v-icon>
                      </div>
                      <p class="accessIndex__text--small" style="margin-top:12px;margin-left:10px">Añadir nueva categoría</p>
                    </v-flex>
                  </div>
                </div>
              </div>
            </div>
          </v-flex>
        </v-flex>

        <v-flex xs1 v-if="excelTitle.length!=0" >
          <v-flex xs11 offset-xs1>
            <section class="data_card data_card__instance">

            </section>
            <div style="margin-left:10vw"
              class="data_card__create_button"
              @click="uploadInfo()">
              Cargar Datos
            </div>
          </v-flex>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      usersJson:{},
      segments:[],
      excelTitle:"",
      isHidden:false,
      renderComponents:true,
      segmentsInfo:{},
      editSegments:[]
    }
  },
  mounted(){

  },
  watch:{

  },
  methods:{
    getSegmentsInfo(){
       try {
        this.$http.get('info_segments',
        {headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()}})
        .then(function(response){
          if(response.body.data!=null|| response.body.data!=undefined){
            this.segmentsInfo = response.body.data;
            var editInfo=[];
            for(var iteration in this.segmentsInfo){
              for(var segment in this.segments){

                if(iteration.toLowerCase().replace(/ /g,'')==this.segments[segment][0].toLowerCase().replace(/ /g,'')){
                  let array_value=[];

                  if (this.segments[segment][1][0][1].length<=0){

                    for(let values in this.segments[segment][1]){
                      array_value.push([this.segments[segment][1][values][0].replace('_',' '),[]]);
                    }
                  }else {this.setMaxRange(this.segments[segment][0].toLowerCase().replace(/ /g,''),this.segments[segment][1][0][1][1])}
                  this.segments.splice(segment,1);



                  for(let segment_value in this.segmentsInfo[iteration]){
                    let name=this.segmentsInfo[iteration][segment_value]["value"].toLowerCase().replace('_',' ');
                    let isIn=true;

                    for(let element in array_value){

                      if (array_value[element][0].toLowerCase().replace('_',' ')==name.toLowerCase().replace('_',' ') ){
                        isIn=false;
                      }
                    }
                    if(isIn){
                      array_value.push([name.charAt(0).toUpperCase() + name.replace('_',' ').slice(1) ,
                                        this.segmentsInfo[iteration][segment_value]["ranges"]]);

                    }
                  }

                  editInfo.push([iteration,array_value]);
                }
              }
            }
            this.editSegments=editInfo;
          }

          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      }
      catch (e) {
        alert(e.message)
      }
    },
    print(value){
    },
    maxRange(segment){
      var self=this;
      var ans=1
      var hh=segment;
      if(!this.usersJson[segment]){
        Object.keys(this.usersJson).forEach(function(x){

          if (x.toLowerCase()==segment){
            hh=x
            return true
          }
        })
      }
      if(this.usersJson[hh]){
        ans=Math.max(Math.max(...Object.values(this.usersJson[hh])),this.getMaxRange(segment.toLowerCase().replace(/ /g,'')))
      }
      if( ans<=1){
        ans=1
      }else if(ans<=10){
        ans=10
      }else if(ans<=100){
        ans=100
      }else{
        ans+=1
      }
      return ans
    },
    setMaxRange(myString,myValue){
      var self=this;
      if(Object.keys(this.segmentsInfo).length>0){
        var ans=null;
        Object.keys(this.segmentsInfo).forEach(function(x){
          if(myString==x.toLowerCase().replace(/ /g,'')&&myValue>self.segmentsInfo[x][self.segmentsInfo[x].length-1]["ranges"][1]){
            self.segmentsInfo[x][self.segmentsInfo[x].length-1]["ranges"][1]=myValue
          }
        })
      }
    },
    getMaxRange(myString){
      var self=this;
      if(Object.keys(this.segmentsInfo).length>0){
        var ans=null;
        Object.keys(this.segmentsInfo).forEach(function(x){
          if(myString==x.toLowerCase().replace(/ /g,'')){
            return self.segmentsInfo[x][self.segmentsInfo[x].length-1]["ranges"][1]
          }
        })
      }
      return null
    },
    sliderStep(myNumber){
      var ans=0;
      if(myNumber<=10){
        ans=0.01
      }else if(myNumber<50){
        ans=0.1
      }
      else{
        ans=1
      }
      return ans;
    },
    moveSlider(characteristic,position,array,myMaxValue){
      var size=array.length;
      var maxValue=myMaxValue;
      let range=characteristic[1];

      if(0!=size-1){
        if(position==0){
          range[0]=0;
          if(range[1]!=array[position+1][1][0]){
            array[position+1][1][0]=range[1];
            if(array[position+1][1][0]> array[position+1][1][1]){
              array[position+1][1][0]=array[position+1][1][1];
              this.moveSlider(array[position+1],position+1,array,myMaxValue);
            }
          }
        }
        else if(position==size-1){
          range[1]=maxValue;
          if(range[0]!=array[position-1][1][1]){
            array[position-1][1][1]=range[0];
            if(array[position-1][1][0]> array[position-1][1][1]){
              array[position-1][1][1]= array[position-1][1][0];
              this.moveSlider(array[position-1],position-1,array,myMaxValue);
            }
          }
        }else{
          if(range[0]!=array[position-1][1][1]){
            array[position-1][1][1]=range[0];
            if(array[position-1][1][0]> array[position-1][1][1]){
              array[position-1][1][1]= array[position-1][1][0];
              this.moveSlider(array[position-1],position-1,array,myMaxValue);
            }
          }
          if(range[1]!=array[position+1][1][0]){
            array[position+1][1][0]=range[1];
            if(array[position+1][1][0]> array[position+1][1][1]){
              array[position+1][1][0]=array[position+1][1][1];
              this.moveSlider(array[position+1],position+1,array,myMaxValue);
            }
          }
        }
        if(range[0]> range[1]){
          range[1]= range[0];
        }

      }else{
        range[0]=0;
        range[1]=maxValue;
      }
      this.renderComponents = false;
      this.$forceUpdate();
      // If you like promises better you can
      // also use nextTick this way
      this.$nextTick().then(() => {
        // Add the component back in
        this.renderComponents = true;
        this.$forceUpdate();
      });

    },
    excelUpload(){
      var fileUpload = document.getElementById("excel_input");
      //Validate whether File is valid Excel file.
      var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx|.ods|.xlsm|.xsv|.txt)$/;
      if (regex.test(fileUpload.value.toLowerCase())) {
          var vm=this;

          if (typeof (FileReader) != "undefined") {
              var reader = new FileReader();
              vm.excelTitle=fileUpload.files[0].name;
              //For Browsers other than IE.
              if (reader.readAsBinaryString) {
                  reader.onload = function (e) {
                      vm.usersJson={};
                      vm.ProcessExcel(e.target.result);
                  };
                  reader.readAsBinaryString(fileUpload.files[0]);
              } else {
                  //For IE Browser.
                  reader.onload = function (e) {
                      var data = "";
                      var bytes = new Uint8Array(e.target.result);
                      for (var i = 0; i < bytes.byteLength; i++) {
                          data += String.fromCharCode(bytes[i]);
                      }
                      vm.ProcessExcel(data);
                  };
                  reader.readAsArrayBuffer(fileUpload.files[0]);
              }
          } else {
              // alert("This browser does not support HTML5.");
              vm.updateAlertMessage("This browser does not support HTML5.");
              vm.updateIsInAlert(true);
          }
      } else {
          // alert("Por favor subir un archivo de códigos válido (Formato Excel).");
          vm.updateAlertMessage("Por favor subir un archivo de códigos válido (Formato Excel).");
          vm.updateIsInAlert(true);
      }
    },

    ProcessExcel(data) {
      //Read the Excel File data.
        var workbook = XLSX.read(data, {
          type: 'binary'
        });

      //Fetch the name of First Sheet.
        let firstSheet = workbook.SheetNames[0];
        var excel=workbook.Sheets[firstSheet];

        let columns=[Object.keys(excel)[1],Object.keys(excel)[Object.keys(excel).length-2]];
        let firstRow, lastRow, firstColumn,lastColumn= 0;
        let cent=true;
        for (var i=0; i<columns[0].length && cent; i++){
          if (!Object.is(Number(columns[0][i]),NaN)){
            firstColumn=columns[0].substring(0,i);
            firstRow=Number(columns[0].substring(i,columns[0].length));
            cent=false;
          }
        }
        cent=true;
        for (var i=0; i<columns[1].length && cent; i++){
          if (!Object.is(Number(columns[1][i]),NaN)){
            lastColumn=columns[1].substring(0,i);
            lastRow=Number(columns[1].substring(i,columns[1].length));
            cent=false;
          }
        }
        var excelSegments={};
        for(let key in excel){
          let cent=true;
          let column,row = 0;
          for (var i=0; i<key.length && cent; i++){
            if (!Object.is(Number(key[i]),NaN)){
              column=key.substring(0,i);
              row=Number(key.substring(i,key.length));
              cent=false;
            }
          }

          if(row==firstRow && column!=firstColumn && (excel[key]["v"].toLowerCase()!="nombre" || excel[key]["v"].toLowerCase()!="apellido" || excel[key]["v"].toLowerCase()!="correo electrónico" || excel[key]["v"].toLowerCase()!="número telefónico")){
            excelSegments[excel[key]["v"]]={"categoría 1":[0,1]};
          }
        }
        this.segments=this.jsonToArray(excelSegments);        

        for(let key in excel){
          if(!key.includes("!")){
            let cent=true;
            let column,row = 0;
            for (var i=0; i<key.length && cent; i++){
              if (!Object.is(Number(key[i]),NaN)){
                column=key.substring(0,i);
                row=Number(key.substring(i,key.length));
                cent=false;
              }
            }
            
            if(column!=firstColumn && row==firstRow){
              this.usersJson[excel[key]["v"]]= {};
            }
            else if(column!=firstColumn && row!=firstRow && (excel[column+firstRow]["v"].toLowerCase()=="nombre")){

              this.usersJson[excel[column+firstRow]["v"]][excel[firstColumn+row]["v"]]=excel[key]["v"];              

            }
            else if(column!=firstColumn && row!=firstRow){
              this.usersJson[excel[column+firstRow]["v"]][excel[firstColumn+row]["v"]]=excel[key]["v"];
              if(Object.is(Number(excel[key]["v"]),NaN)){
                for(let value in this.segments){

                  if (this.segments[value][0].toLowerCase()==excel[column+firstRow]["v"].toLowerCase()){
                    if(this.segments[value][1][0][0]=="categoría 1"){
                      this.segments[value][1].shift();
                    }

                    let cent=true;
                    for(let seg_value in this.segments[value][1]){

                      if(this.segments[value][1][seg_value][0]==excel[key]["v"]){
                        cent=false;
                      }
                    }
                    if(cent){
                      this.segments[value][1].push([excel[key]["v"],""]);
                    }
                  }
                }

              }
            }
          }
        }
        this.capitalizeSegments()
        // this.getSegmentsInfo();
    },
    jsonToArray(json){
      var array=[];

      for(let key in json){
        console.log()
        if(key.toLowerCase()!="nombre"&&key.toLowerCase()!="apellido"&&key.toLowerCase()!="rut"&&key.toLowerCase()!="correo electrónico"&&key.toLowerCase()!="número telefónico"){
          let characteristicArray = array.push([key,[["categoría 1",[0,1]]]]);
        }
      }
      return array;
    },
    capitalizeSegments(){
      for(var seg in this.segments){
        if(this.segments[seg][1][0][1].length>0){
          this.segments[seg][1][0][1][1]=this.maxRange(this.segments[seg][0].toLowerCase())
        }
        this.segments[seg][0]=this.segments[seg][0].charAt(0).toUpperCase()+this.segments[seg][0].substring(1,this.segments[seg][0].length)
      }
    },
    addSegmentValue(segment){
      var greaterSegment=segment[segment.length-1];
      let greaterIntervalus=greaterSegment[1][1]-greaterSegment[1][0]
      let newValue=Number((greaterIntervalus/2).toFixed(2));

      segment.push(["categoría "+Number(segment.length+1),[(Number(greaterSegment[1][0])+Number(newValue)).toFixed(2),greaterSegment[1][1]]])
      greaterSegment[1][1]=Number((Number(greaterSegment[1][0])+Number(newValue.toFixed(2))).toFixed(2));
      this.renderComponents = false;
      this.$forceUpdate();
      // If you like promises better you can
      // also use nextTick this way
      this.$nextTick().then(() => {
        // Add the component back in
        this.renderComponents = true;
        this.$forceUpdate();
      });
      // for(let seg in segment){
      //   let intervalus=segment[seg][1][1]-segment[seg][1][0]
      //   sum+=intervalus;
      //   if(intervalus>=greaterIntervalus){
      //     greaterIntervalus=intervalus;
      //     greaterSegment=segment[seg];
      //   }
      // }

      // for(let seg in this.segments[segment]){
      //   if(this.segments[segment][seg]==greaterSegment){
      //     let middleData=greaterSegment[1]-(greaterIntervalus/2).toFixed(2);
      //     this.segments[segment]["Default"+(Number(Object.keys(this.segments[segment]).length)+1)]=[Number(middleData.toFixed(2)),Number(greaterSegment[1])];
      //     this.segments[segment][seg]=[greaterSegment[0],middleData];
      //   }
      // }

    },
    deleteValue(array,row){
      let next=-1;
      let greater=0;
      if(row<=0){
        row=0;
        next=1;
        greater=1;
      }else if(row>=array[1].length-1){
        row=array[1].length-1
        next=array[1].length-2;
        greater=-1;
      }else{
        if(array[1][row+1][1][1]-array[1][row+1][1][0]>=array[1][row-1][1][1]-array[1][row-1][1][0]){
          next=row-1;
          greater=-1
        }else{
          next=row+1;
          greater=1;
        }
      }

      let addition=Number((array[1][row][1][1]-array[1][row][1][0]).toFixed(2));

      if(greater>0){
        array[1][next][1][0]-=addition;
        array[1][next][1][0]=Number(array[1][next][1][0].toFixed(2))
      }else{
        array[1][next][1][1]=Number(array[1][next][1][1])+Number(addition);
        array[1][next][1][1]=Number(array[1][next][1][1].toFixed(2))
      }
      array[1].splice(row,1);

      this.renderComponents = false;
      this.$forceUpdate();
      // If you like promises better you can
      // also use nextTick this way
      this.$nextTick().then(() => {
        // Add the component back in
        this.renderComponents = true;
        this.$forceUpdate();
      });
    },
    uploadInfo(){
      let finalJson={new: this.segments, old:this.editSegments, data: this.usersJson, company:{id:this.getCompany().id}}

      try{
        this.$http.post('upload_data',{
          data: this.encrypt(finalJson).toString()
        },{
          headers: {
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken()
          }
        }).then(function(response){

          this.$router.push({name: 'segments'});

          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          this.updateAlertMessage('Ha ocurrido un error cargando los datos, por favor intentalo nuevamente.')
          this.updateIsInAlert(true);
        })

      }catch (e) {
        alert(e.message)
      }
    },
    arraySegments(segment){

      var array=[];
      var maxNumber=1;
      for(let value in segment){
        array.push([value,segment[value]]);
      }
      array.sort(function(a,b){
        return ((a[1] === b[1]) ? 0 : ((a[1] > b[1]) ? 1 : -1));
      })
      return array;
    },
    // order(array){
    //   if(array[0][1]!=""){
    //     array.sort(function(a,b){
    //       return ((a[1][1] === b[1][1]) ? 0 : ((a[1][1] > b[1][1]) ? 1 : -1));
    //     })
    //   }
    //   return array;
    // },
    isNewSegment(segment){
      var ans=true;
      var editInfo={};
      for(var iteration in this.segmentsInfo){
        if(iteration.toLowerCase().replace(/ /g,'')==this.segments[segment][0].toLowerCase().replace(/ /g,'')){
          // editInfo[iteration]=this.segmentsInfo[iteration].ranges
          ans=false;
        }
      }
      return ans;
    }
  }

}
</script>

<style lang="css">
p{
  margin-bottom: 0;
}

.text_title{
  font-weight: bold;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/segments/New_segments_data.vue